import React from 'react'
import {
  Language,
  ShoppingCart,
  Phone,
  Email,
  LocationOn,
  DateRange,
  Visibility,
  Instagram,
  Twitter,
  WhatsApp,
  Facebook,
} from '@material-ui/icons'
import { ReactComponent as Tripadvisor } from 'assets/icons/tripadvisor.svg'
import InputAdornment from '@material-ui/core/InputAdornment'
import { makeStyles } from '@material-ui/core/styles'

const classes = makeStyles(theme => ({
  icon: {
    fill: `#007BFF`,
    opacity: 0.4,
    width: 25,
    height: 25,
  },
  buttonClass: {
    margin: theme.spacing(1, 0),
  },
  pointer: {
    cursor: `pointer`,
  },
}))

export default function InputIcon({ icon, button = false, onClick = () => null }) {
  const { icon: iconClass, buttonClass, pointer } = classes()

  function getIcon() {
    const className = `${iconClass} ${button && buttonClass} ${
      icon === `visibility` ? pointer : ``
    }`
    switch (icon) {
      case `shoppingCart`: {
        return <ShoppingCart className={className} />
      }
      case `map`: {
        return <LocationOn className={className} />
      }
      case `email`: {
        return <Email className={className} />
      }
      case `phone`: {
        return <Phone className={className} />
      }
      case `internet`: {
        return <Language className={className} />
      }
      case `tripadvisor`: {
        return <Tripadvisor className={className} />
      }
      case `facebook`: {
        return <Facebook className={className} />
      }
      case `twitter`: {
        return <Twitter className={className} />
      }
      case `whatsapp`: {
        return <WhatsApp className={className} />
      }
      case `instagram`: {
        return <Instagram className={className} />
      }
      case `month`: {
        return <DateRange className={className} />
      }
      case `visibility`: {
        return <Visibility className={className} onClick={onClick} />
      }
      default: {
        return <Language className={className} />
      }
    }
  }

  return <InputAdornment position="end">{getIcon()}</InputAdornment>
}
